import React ,{Component} from 'react'; 
import { Navigate  } from 'react-router-dom';
import axios from 'axios'; 
import Table from '@mui/material/Table';
import Serverurl from './Apiurl';
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';
import TableRow from '@mui/material/TableRow'; 
import { makeStyles } from '@mui/styles'; 
import Paper from '@mui/material/Paper';  
import TableSortLabel from '@mui/material/TableSortLabel';
import TableBody from '@mui/material/TableBody'; 
import TableCell from '@mui/material/TableCell';  
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';  
import TablePagination from '@material-ui/core/TablePagination'; 
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import Dialog from '@mui/material/Dialog';

import DialogContent from '@mui/material/DialogContent';

import DialogTitle from '@mui/material/DialogTitle';

import Select from '@mui/material/Select';

import FormControl from '@mui/material/FormControl';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import pageimg from './images/attendance.png';

 let strbr=[{title:'',id:0}];

const headCells = [


 
  
  { id: 'ur_name', numeric: false, label: 'Name' },
  { id: 'role', numeric: false, label: 'Role' },
  { id: 'ur_phonenumber', numeric: false, label: 'Phone No.' },
  { id: 'ur_username', numeric: false, label: 'Username' },
   { id: 'br_title', numeric: false, label: 'Branch' },
   { id: '',  label: '' },
  ]
  
  

 
 function stableSort(array, cmp) {
	  const stabilizedThis = array.map((el, index) => [el, index]);
	  stabilizedThis.sort((a, b) => {
		const order = cmp(a[0], b[0]);
		if (order !== 0) return order;
		return a[1] - b[1];
	  });
	  return stabilizedThis.map(el => el[0]);
}
function desc(a, b, orderBy) {
	  if (b[orderBy] < a[orderBy]) {
		return -1;
	  }
	  if (b[orderBy] > a[orderBy]) {
		return 1;
	  }
	  return 0;
}
function getSorting(order, orderBy) {
	return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}
 
function EnhancedTableHead(props) {
  const { classes,  order, orderBy,  rowCount, onRequestSort } = props;
  const createSortHandler = property => event => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        
        {headCells.map(headCell => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'default'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={useStyles.visuallyHidden}>
                  {order === 'desc' ? ' ' : ' '}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
 
  onRequestSort: PropTypes.func.isRequired,
 
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};
const useToolbarStyles = makeStyles(theme => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  
  
  title: {
    flex: '1 1 100%',
  },
}));

const EnhancedTableToolbar = props => {
  const classes = useToolbarStyles();
  const { numSelected } = props;

  };

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};


const useStyles = makeStyles({  
  root: {  
    width: '100%',  
  },  
  container: {  
    maxHeight: 440,  
  }, 
 icon: {
   verticalalign:'middle',
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },  
});


export default class Usermaster extends Component {
	
    constructor(props) {
    super(props);
   
      this.state = {redirect: false,
      Userdata:[],urid:'',page: 0 ,prevpage:0,totaldata:0,rowsPerPage:50,rowsPaging:[],
	 
	  order:'desc' ,orderBy:'',roles:'',names:'',brancharray:[],branch:'0',rolelabel:'Select Branch',searchcustomer:'',brarrauto:[],
	          
      }
       this.updateDonenewParent = this.updateDonenewParent;
	   
	}
	
	updateDonenewParent = (text) => {this.componentDidMount();  }
	
	Search(){
	this.setState({  
      page: 0,
      rowsPerPage:50,
	  prevpage:0,Userdata:[]
    });
	
//this.componentDidMount();  
}
		componentWillMount() { 
localStorage.setItem("pageactive",4)
}
componentDidUpdate() {
	
  if(this.state.prevpage !== this.state.page) {
    this.setState({   prevpage: this.state.page});
  this.apicall(this.state.page, localStorage.getItem("page"));  
  }
}




	componentDidMount() {
	


	 
		
	
	
	document.title = "MM Coching Center - User Management";
	
	/*if(localStorage.getItem("MMCuserid")==null)
		  {

		   this.setState({
            redirect: true,
			pagename:'/Login'
          })
		  }*/
	
	
	
	  localStorage.setItem("page",this.state.rowsPerPage)
  this.apicall(this.state.page,this.state.rowsPerPage);
  


    //this.AutoBranchBind();

  this.onloadbranchbind();
} 



onloadbranchbind(){

    axios.get(Serverurl+"ajaxbranch.php?action=getall")
	
    
      .then((response) => {    
     
      this.setState({  brancharray: response.data,  });
      })   
    
      .then(data => {
        let roleFromApi = this.state.brancharray.map(branch => {
                            
          return {value: branch.br_id, display:branch.br_title}
        });
      
		
        this.setState({
          brancharray: [{value: '0', display: 'Select Branch'}].concat(roleFromApi)
        });
      })
  
  
  }
  


handleClickSearch=()=>{   
 
  
  this.apicall(this.state.page,this.state.rowsPerPage); 

	
} 

myChangeHandler = (event) => {
  let nam = event.target.name;
  let val = event.target.value;
  this.setState({[nam]: val});
 
}

apicall(page,rowsPerPage){
	 
	 axios.get(Serverurl+'ajaxuser.php?action=getall&ur_role='+this.state.roles+'&ur_name='+this.state.names+'&ur_br_id='+this.state.branch+'&StartIndex='+page+'&PageSize='+rowsPerPage)
     
	
  .then(resp => {  
		
    if(resp.data.length>0){
		
			this.setState({  
			  Userdata: resp.data,  
			   totaldata:parseInt(resp.data[0].count),
			   

		    });
		
			
			let copy=[50, 100, 150, 200, 250];
			
	  
	  this.setState({rowsPaging:copy});
	 
     }
	 else{
		   this.setState({Userdata:[],totaldata:0});
	 }
 
    });
}





handleChangePage = (event, newPage) => {  
   
    let pageval = localStorage.getItem("page");
    this.setState({  
      page: newPage,
      rowsPerPage:parseInt(pageval)
    });
   
 
    setTimeout(() =>  this.componentDidUpdate() ,500); 
  };  
  
  
   handleChangeRowsPerPage = event => {  
  
    let pageval = event.target.value;
    localStorage.setItem("page",pageval)

    setTimeout(() =>  this.componentDidUpdate() ,500);
    this.setState({  
      page: 0,
      rowsPerPage:parseInt(pageval),
	  prevpage:-1
    }); 
	
	
  }; 
  
  
  handleRequestSort = (event, property) => {
  const isAsc = this.state.orderBy === property && this.state.order === 'asc';
  

  this.setState({   orderBy: property,
    order:isAsc  ? 'desc' : 'asc'
   
  });
};


      userDelete(urid){  
	
let r = window.confirm("Do you really want to Delete?");
 if(r === true){ //sign Out logic
 var formData = new FormData();
     formData.append('action','delete')
	 formData.append('ur_id',urid)
	 	   
formData.append('userid',localStorage.getItem("MMCuserid"))	
	
	
	 axios.post(Serverurl+"ajaxuser.php", formData, {
        }).then(res => {
    
             this.setState({  
      prevpage: -1,
    
    });
   
 
    setTimeout(() =>  this.componentDidUpdate() ,500); 
  
    
            });
 }
      }
      Useraddbox(val){
        this.setState({ urid: val });  
  
         setTimeout(() => this.refs.AddUserbox.handleClickOpen(),500);

      }

render() {

if (this.state.redirect === true) {
      return <Navigate to={this.state.pagename} />
    }


  return (
  
  
  



 
  <React.Fragment>
   
<div className="containermain">
<div className="boxheading">
				  <div className="contntpad">
<h2><img src={pageimg}/>User Management</h2>
</div></div>

   <div className="searchmaster">


  
  <ul>
  

		
		<li>
 <p ><TextField
            variant="outlined"
            margin="normal"
            fullWidth value={this.state.names}
           inputProps={{tabIndex: "1",maxLength:150}}
			placeholder="Name"
            name="names" onChange={this.myChangeHandler}
		
          /></p></li>
			 <li>
 	<p><FormControl  className="stadrp">			   
		<Select
		variant="outlined"
		native
		value={this.state.roles}
		onChange={this.myChangeHandler}
		name='roles'
		id='roles'
		placeholder="Role"
		InputLabelProps={{
		shrink: true,
		}}
		>
		<option value={0}>Select Role</option>
		<option value={1}>Admin</option>
		<option value={2}>Co-Ordinator</option>
		<option value={3}>Teacher</option>	
		<option value={4}>Exam Co-Ordinator</option>		
		
		</Select>
		</FormControl></p>	
</li>
	<li>
	<p><FormControl  className="stadrp">
         
        <Select
         native  fullWidth
		 
		 
		 variant="outlined"
            margin="normal"
		  defaultValue={{ label: this.state.rolelabel, value: this.state.branch }}
          onChange={this.myChangeHandler}
          id="branch"
		   value={this.state.branch}
		  name="branch"
		
		
        >
		{this.state.brancharray.map(branch => (
            <option  
            
              value={branch.value}
            >
              {branch.display}
            </option  >
          ))}
		
        </Select></FormControl>
		
				</p>
	</li></ul>
		
	
		<div className="searchnewbtn">
		<p className="searchbutton">
		<Button variant="contained" onClick={this.handleClickSearch} className={useStyles.submit} endIcon={<SearchIcon />}>
        Search
      </Button>	</p>
	  <p className="addnewbtn"><Button variant="contained" onClick={()=>{this.Useraddbox(0)}} className="pointerbtn" endIcon={<AddIcon />}>
        New
      </Button></p>
		
		
		</div>	
		
		
</div>		



<AddUserbox ref="AddUserbox" id={this.state.urid}  updateDonenew={this.updateDonenewParent}/>
<Paper className={useStyles.root}>


  <TableContainer className={useStyles.container}>  
                <Table stickyHeader aria-label="sticky table">  
<TableHead> 
<TableRow>
                                              
                       
						
                      </TableRow></TableHead>
					  
					   <EnhancedTableHead           
              order={this.state.order}
              orderBy={this.state.orderBy}
              
              onRequestSort={this.handleRequestSort}
              rowCount={this.state.Userdata.length}
            />
                      <TableBody>
                     {stableSort(this.state.Userdata, 
			getSorting(this.state.order,
			this.state.orderBy)).map((item,index) => {  
           return (
 <React.Fragment>
 <TableRow key={index} >



<TableCell>{item.ur_name}</TableCell>
<TableCell>{item.role}</TableCell>
<TableCell>{item.ur_phonenumber}</TableCell>
<TableCell>{item.ur_username}</TableCell>
<TableCell>{item.br_title}</TableCell>
<TableCell align="left">
<div className="actionbtns">
<Button variant="contained" className="frmPrimarybtn" onClick={()=>{this.Useraddbox(item.ur_id)}} endIcon={<EditIcon />}>
Edit
</Button>

 
 
{item.ur_role !=='1' &&(<React.Fragment> 
 
<Button variant="contained" className="admsndisablebtn" onClick={()=>{this.userDelete(item.ur_id)}} endIcon={<DeleteIcon />}>
  Delete
</Button> 
 </React.Fragment>)}
 
 </div>
 
 </TableCell>
 </TableRow>

 </React.Fragment>	
);
					})}
					
					{this.state.totaldata===0 &&(
					
					<TableRow key={0} >
<TableCell align="center" colSpan="4">No Records</TableCell>
					</TableRow>
					) }
					
                      </TableBody>


</Table>
  </TableContainer> 
  <TablePagination  
        rowsPerPageOptions={[50, 100, 150, 200, 250]}  
        component="div"  
        count={this.state.totaldata}  
        rowsPerPage={this.state.rowsPerPage}  
        page={this.state.page}  
        onPageChange={this.handleChangePage}  
        onChangeRowsPerPage={this.handleChangeRowsPerPage}  
      />   
  </Paper>
    
</div>
 </React.Fragment> 

 
 
  );
}
}


export  class  AddUserbox extends Component {
   constructor(props) {
      super(props)
      this.state = {
		   open:false,name:'',ur_id:0,brancharray:[],branch:'',rolelabel:'Select Branch',contactnumber:'',username:'',
      errormessage:'',erropen:false, branchSearch: '',brarrauto: [],brarr: [],
	  }
  }
  componentDidMount() {
	this.AutoBranchBind();
}
  handleBranchSearch = (event) => {
    const value = event.target.value;
    this.setState({ branchSearch: value });
	this.AutoBranchBind(event);
};
  AutoBranchBind = (event) => {
    axios.post(Serverurl + 'ajaxbranch.php?action=branchextender&br_title=' + this.state.branchSearch)
        .then((resp) => {
            if (resp.data.length > 0) {
                this.setState({ produserarray: resp.data });
                var rowsArrayp = resp.data;
                let strbr = [...this.state.brarrauto]; 
                rowsArrayp.map((row) => {
                    const items = {
                        title: row.br_title,
                        id: row.br_id,
                    };
                    const cusfound = strbr.some(el => el.id === row.br_id);
                    if (!cusfound) strbr.push(items);
                });          
                this.setState({ brarrauto: strbr });
            } else {
                this.setState({ brarrauto: [] });
            }
        })
};
onloadbranchbind() {
  axios.get(Serverurl + "ajaxbranch.php?action=getall")
    .then((response) => {
      const branches = response.data;
      this.setState({ brancharray: branches });
      let formatted = branches.map(branch => ({
        value: branch.br_id,
        display: branch.br_title
      }));
      this.setState({
        brancharray: [{ value: '0', display: 'Select Branch' }].concat(formatted)
      });
      if (this.state.role === 3 && this.state.branch) {
        const selectedIds = this.state.branch.split(',');
        const matched = branches
          .filter(branch => selectedIds.includes(branch.br_id))
          .map(branch => ({
            title: branch.br_title,
            id: branch.br_id
          }));
        this.setState({ brarr: matched });
      }
    });
}
Usergetdata() {
  if (this.props.id !== 0) {
    axios.get(Serverurl + 'ajaxuser.php?action=getall&ur_id=' + this.props.id)
      .then(resp => {
        if (resp.data.length > 0) {
          const user = resp.data[0];
          const isTeacher = user.ur_role === 3;
         const selectedIds = user.ur_br_id ? user.ur_br_id.split(',') : [];
          this.setState({
            ur_id: user.ur_id,
            name: user.ur_name,
            contactnumber: user.ur_phonenumber,
            username: user.ur_username,
            branch: selectedIds, // Array of selected branch IDs
            role: user.ur_role,passwords:user.ur_password,
            branchSearch: '', // Optional
          });
         if (!isTeacher) {
  axios.post(Serverurl + 'ajaxbranch.php?action=branchextender')
    .then((resp2) => {
      if (resp2.data.length > 0) {
        const allBranches = resp2.data;
        const selectedBranches = allBranches
          .filter(branch => selectedIds.includes(branch.br_id))
          .map(branch => ({
            title: branch.br_title,
            id: branch.br_id
          }));
        this.setState({
          brarrauto: allBranches.map(branch => ({
            title: branch.br_title,
            id: branch.br_id
          })),
          brarr: selectedBranches,
          branch: selectedBranches.map(x => x.id)
        });
      }
	  });
}
        }
      });
  } else {
    // If adding a new user
    this.setState({
      name: '',
      username: '',
      contactnumber: '',
      ur_id: 0,
      branch: '',
      brarr: [],
      brarrauto: []
    });
  }
}
 /*Usergetdata() {
  if(this.props.id!==0)
  {
	   axios.get(Serverurl+'ajaxuser.php?action=getall&ur_id='+this.props.id)
  .then(resp => {  
    if(resp.data.length>0){
    this.setState({ 
      ur_id:resp.data[0].ur_id,
	  name: resp.data[0].ur_name,
      contactnumber: resp.data[0].ur_phonenumber, 
		username: resp.data[0].ur_username, 
		branch: resp.data[0].ur_br_id, 
role:resp.data[0].ur_role, 	
branchSearch: resp.data[0].ur_br_id,	
    });
			if (resp.data[0].ur_role === 3) {
                        this.AutoBranchBind({ target: { value: resp.data[0].ur_br_id } });  
                    }
  }
});
  }else{
	 this.setState({  
	  name:'',
	 username:'',
	 contactnumber:'',
	 ur_id:0,
	 branch:''
	  }); 
 }
    }*/
handleClickOpen = (e) => {
  this.setState({open:!this.state.open,  name:'',username:'',brancharray:[],branch:'',contactnumber:'',passwords:'',role:'', 
     errormessage:'',erropen:false,brarrauto: [],brarr:[],
	  });
		this.Usergetdata();
		this.onloadbranchbind();
if (this.state.role === "3") { 
    this.AutoBranchBind(); 
  }
};
myChangeHandler = (event) => {
  const re = /^[0-9\b]+$/;
  let nam = event.target.name;
  let val = event.target.value;
  if (nam === "contactnumber") {
    if (val === '' || re.test(val)) {
      this.setState({ [nam]: val });
    }
  } else if (nam === 'branch' && this.state.role === 3) {
    this.setState({ [nam]: val },
	() => {
      this.AutoBranchBind(); 
    });
  } else {
    this.setState({ [nam]: val });
  }
}
 handleErrorclose=(event)=>{
	this.setState({open: false});  
  }
handleClose = (e) => {
	let role = this.state.role;
 let name = this.state.name;
 let contactnumber = this.state.contactnumber;
 let username = this.state.username;
 let passwords = this.state.passwords;
  let branch = this.state.branch;
if (this.state.role === 3) {
  branch = this.state.branch.join(',');
}
if(role==="")
{
	this.setState({errormessage:"Please Select Role",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
}
if(name==="")
{
	this.setState({errormessage:"Please Enter Name",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
}
if(contactnumber==="")
{
	this.setState({errormessage:"Please Enter Contact Number",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
}
if(username==="")
{
	this.setState({errormessage:"Please Enter Username ",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
}
if(passwords==="")
{
	this.setState({errormessage:"Please Enter Password ",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
}
if(branch==="")
{
	this.setState({errormessage:"Please Select Branch",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
}
   var formData = new FormData();
   if(this.state.ur_id===0)
	  {
		  formData.append('ur_id',0) 
	  }
	  else
	  {
	   formData.append('ur_id',this.state.ur_id)
          }
        formData.append('action','insert') 
		formData.append('ur_role',role)
		formData.append('ur_name',name)
		formData.append('ur_phonenumber',contactnumber)
		formData.append('ur_username',username)
		formData.append('ur_password',passwords)
if (this.state.role === "3" && Array.isArray(branch)) {
  let strsep = "", strids = "";
  branch.map((item) => {
    strids = strids + strsep + item;
    strsep = ",";
  });
  branch = strids; 
}
formData.append('ur_br_id', branch);
		//formData.append('ur_br_id',branch)
		formData.append('userid',localStorage.getItem("MMCuserid"))
		//formData.append('userid',localStorage.getItem("MMCuserid"))
		axios.post(Serverurl+"ajaxuser.php", formData, {
        }).then(res => {
	if(res.data === -1)
{ 
		this.setState({errormessage:"Name Already Exist.",erropen:true,open:true
		});
		window.scrollTo({
          top: 0
      })
		 return false;
	}
            this.props.updateDonenew();
        });
	this.setState({ open:false });
};
	 handleErrorclose=(event)=>{
	this.setState({erropen: false});  
  } 
render (){
return(
<React.Fragment>
    <Dialog open={this.state.open} onClose={this.handleClose} maxWidth="md" fullWidth="true" aria-labelledby="form-dialog-title">
      <DialogTitle id="form-dialog-title"> User Management</DialogTitle>
      <DialogContent>
<div className="formlist">
	<p>  <Collapse in={this.state.erropen}>
        <Alert
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
               this.handleErrorclose();
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          } severity="error"
        >
        {this.state.errormessage}
        </Alert>
      </Collapse></p>
		<ul>
	<li><p> <span className="validation">*</span> Name</p>
	<p><TextField name="name" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   size="small"
	   value={this.state.name}
			  ref={this.usernameInput}
			  inputProps={{tabIndex: "1",maxLength:150}} 
	   InputLabelProps={{ shrink: true }}
                          /></p></li>
	<li><p> <span className="validation">*</span> Phone Number</p>
	<p><TextField name="contactnumber" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   size="small"
	   value={this.state.contactnumber}
			  ref={this.usernameInput}
			  inputProps={{tabIndex: "2",maxLength:13}} 
	   InputLabelProps={{ shrink: true }}
                          /></p></li>
<li><p> <span className="validation">*</span> Username</p>						  
	<p><TextField name="username" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   value={this.state.username}
			  ref={this.usernameInput}
			  inputProps={{tabIndex: "3",maxLength:150}} 
	   InputLabelProps={{ shrink: true }}
                          /></p></li>
		<li><p> <span className="validation">*</span> Password</p>						  
	<p><TextField name="passwords" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   value={this.state.passwords}
			type="password" 
			  ref={this.usernameInput}
			  inputProps={{tabIndex: "4",maxLength:15}} 
	   InputLabelProps={{ shrink: true }}
                          /></p>	</li>
<li>		
	 <p><span className="validation">*</span> Role</p>
		<p><FormControl  className="stadrp">			   
		<Select
		variant="outlined"
		native
		value={this.state.role}
		onChange={this.myChangeHandler}
		name='role'
		id='role'
		InputLabelProps={{
		shrink: true,
		}}
		>
		<option value={0}>Select</option>
		<option value={1}>Admin</option>
		<option value={2}>Co-Ordinator</option>
		<option value={3}>Teacher</option>		
		<option value={4}>Exam Co-Ordinator</option>		
		</Select>
		</FormControl></p>	</li>							  
		{/*
		<li><p> <span className="validation">*</span> Branch</p>
		<p><FormControl  className="stadrp">
        <Select
         native  fullWidth
		 variant="outlined"
            margin="normal"
		  defaultValue={{ label: this.state.rolelabel, value: this.state.branch }}
          onChange={this.myChangeHandler}
          id="branch"
		   value={this.state.branch}
		  name="branch"
        >
		{this.state.brancharray.map(branch => (
            <option  
              value={branch.value}
            >
              {branch.display}
            </option  >
          ))}
        </Select></FormControl>
				</p>
</li>*/}
				{this.state.role === "3" ? (
  <li>
    <p><span className="validation">*</span> Branch</p>
    <p>
      <Autocomplete
  multiple
  style={{ width: '100%' }}
  fullWidth
  className="txtboxs"
  options={this.state.brarrauto}
  value={this.state.brarr} 
  onChange={(event, newValue) => {
    this.setState({
      brarr: newValue,
      branch: newValue.map(item => item.id)
    });
  }}
  onInputChange={(event, newInputValue) => {
    this.setState({ branchSearch: newInputValue }, () => {
      this.AutoBranchBind();
    });
  }}
  getOptionLabel={(option) => option.title}
  renderOption={(props, option) => (
          <li
            {...props}
            style={{
              opacity: this.state.brarr.some((v) => v.id === option.id) ? 0.5 : 1,
              pointerEvents: this.state.brarr.some((v) => v.id === option.id) ? 'none' : 'auto',
            }}
          >
            {option.title}
          </li>
        )}
  renderInput={(params) => (
    <TextField
      {...params}
      variant="outlined"
      fullWidth
      placeholder="Search Branch"
    />
  )}
/>
    </p>
  </li>
) : (
  <li>
    <p><span className="validation">*</span> Branch</p>
    <p>
      <FormControl className="stadrp">
        <Select
          native
          fullWidth
          variant="outlined"
          margin="normal"
          value={this.state.branch}
          onChange={this.myChangeHandler}
          name="branch"
          id="branch"
        >
          {this.state.brancharray.map(branch => (
            <option key={branch.value} value={branch.value}>
              {branch.display}
            </option>
          ))}
        </Select>
      </FormControl>
    </p>
  </li>
)}
			  </ul>
       <div className="actionbtns">
<div className="cancelbtn">	  
        <Button onClick={this.handleClickOpen} color="secondary">
          Cancel
        </Button></div> 
<div className="savebtn">
        <Button onClick={this.handleClose} color="secondary">
          Save
        </Button>
		</div>
<div className="clear"></div>
 </div>     
 </div> 		
 </DialogContent>
    </Dialog>
</React.Fragment>
) }
} 